import React from 'react';
import { Link } from 'react-router-dom';

const SingleItem = ({ data,  handleEnableDisabled,  handleDelete }) => {
    return (
        <>
            <tr>
                <td data-label="Name">
                  {data?.name}
                </td>
                <td data-label="Image">
                    <div className="user">
                        <div className="thumb">
                            <img src={`https://api.velormall.com/${data?.image}`} alt="" />
                        </div>
                    </div>
                </td>
                <td data-label="Price">{data?.price}</td>
                <td data-label="Platform Type">{data?.platformType?.name}</td>
                <td data-label="Quantity">{data?.quantity}</td>
                <td data-label="Status">
                    {data?.status ? (
                        <span class="badge badge--success text-success">Enabled</span>
                    ) : (
                        <span>
                            <span class="badge badge--warning text-warning">Disabled</span>
                        </span>
                    )}
                </td>
                <td data-label="Action">
                    <Link to={`/admin/product/edit/${data?._id}`} class="btn btn-sm btn-outline-primary"><i class="la la-pencil-alt"></i> Edit</Link>
                    {data?.status ? (
                        <button
                            onClick={() => handleEnableDisabled(data?._id)}
                            class="btn btn-sm btn-outline-danger confirmationBtn"
                        >
                            <i class="la la-eye-slash"></i> Disable
                        </button>
                    ) : (
                        <button
                            onClick={() => handleEnableDisabled(data?._id)}
                            class="btn btn-sm btn-outline-success confirmationBtn"
                        >
                            <i class="la la-eye"></i> Enable
                        </button>
                    )}
                    <button class="btn btn-sm btn-outline-danger " onClick={() => handleDelete(data?._id)} ><i class="la la-trash"></i> Remove</button>
                </td>
            </tr>
        </>
    );
};

export default SingleItem;